import { useMutation } from 'react-query';
import {
  createHomeAssistantIntegrationAsync,
  getHomeAssistantIntegrationByIdAsync,
  deleteHomeAssistantIntegrationAsync,
  updateHomeAssistantIntegrationAsync,
} from '../..';

export const useCreateHomeAssistantIntegrationAsync = () =>
  useMutation(createHomeAssistantIntegrationAsync);

export const useGetHomeAssistantIntegrationByIdAsync = () =>
  useMutation(getHomeAssistantIntegrationByIdAsync);

export const useUpdateHomeAssistantIntegrationAsync = () =>
  useMutation(updateHomeAssistantIntegrationAsync);

export const useDeleteHomeAssistantIntegrationAsync = () =>
  useMutation(deleteHomeAssistantIntegrationAsync);
